export const bannerContainerStyles = {
  position: 'sticky',
  top: 0,
  zIndex: 1100,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  padding: '6px 16px',
  backgroundColor: ({ palette }) => palette.info.main,
  color: ({ palette }) => palette.info.contrastText,
  cursor: 'pointer',
  minHeight: '36px',
};

export const bannerTextStyles = {
  color: 'inherit',
};

export const closeButtonStyles = {
  color: 'inherit',
  padding: '2px',
  marginLeft: '4px',
};
